import { css } from '@/styled-system/css';

// Individual card styling for pet policy cards
export const petCardItem = css({
  display: 'flex',
  flexDirection: 'column',
});

export const petCard = css({
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

// Container for individual pet details within each card
export const petDetails = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
  width: '100%', // Ensure it doesn't exceed parent width
  minWidth: 0, // Allow flex children to shrink below content size (Constellation v10 pattern)
  flex: 1, // Grow to fill available space in card
  // Allow content expansion for ReadMore functionality
});

// Styling for pet icons (dog/cat)
export const petIcon = css({
  width: '24px',
  height: '24px',
  flexShrink: 0,
  // Apply teal color to SVG icons
  '& path': {
    fill: 'hpxTeal500',
  },
  // Fallback for different SVG structures
  color: 'hpxTeal500',
});

// Container for additional information section (restrictions/comments)
export const additionalInfo = css({
  marginTop: '2x',
  paddingTop: '2x',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderColor: 'hpxGrey400',
  width: '100%', // Constrain to parent width
  minWidth: 0, // Allow shrinking below content size
});

// Label styling for additional information sections
export const infoLabel = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  fontWeight: 'bold',
  marginBottom: 'xs',
});

// Content styling for additional information
export const infoContent = css({
  fontSize: 'sm', // 14px for additional info text (comments/restrictions)
  color: 'hpxBlue500',
  lineHeight: '1.5',
  wordWrap: 'break-word', // Allow long words to break and wrap
  overflowWrap: 'break-word', // Modern alternative to word-wrap
  wordBreak: 'break-word', // Break long words at arbitrary points if necessary
  hyphens: 'auto', // Add hyphens for better readability when breaking words
});

// Spacing between additional info sections (restrictions vs comments)
export const additionalInfoSection = css({
  marginTop: '2x', // 16px spacing between sections
});

// No data state message styling
export const noDataMessage = css({
  textAlign: 'center',
  color: 'hpxGrey600',
  fontSize: 'md',
  paddingTop: '4x',
  paddingBottom: '4x',
  paddingLeft: '2x',
  paddingRight: '2x',
  fontStyle: 'italic',
});
